import {
  colors,
  createStaticStyles,
  cssFns,
  FilterButton,
  useScreenDetector,
  useStaticStyles,
} from "@hermes/ui";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useAppConfig } from "#internal/app/config";
import { useRoutePath } from "#internal/app/router";
import { SearchBar } from "#internal/features/search-bar";

import { DoctorListFilters, type DoctorListFiltersProps } from ".";

const styles = {
  container: createStaticStyles({
    common: [
      cssFns.boxShadow({
        offsetY: "6px",
        blurRadius: "10px",
        color: "rgba(0, 0, 0, 0.08)",
      }),
      {
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 100,
        backgroundColor: colors.principal.white,
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        alignItems: "start",
        gap: 6,
        opacity: 0,
        transform: "translateY(-10px)",
      },
    ],
    mobile: [cssFns.padding(10)],
    desktop: [
      cssFns.paddingBlock(12),
      {
        display: "grid",
        gridTemplateColumns: "1fr 1010px 1fr",
      },
    ],
  }),
  filters: createStaticStyles({
    desktop: {
      display: "grid",
      gridTemplateColumns: "minmax(230px, auto) 1fr",
      columnGap: 16,
    },
  }),
  logo: createStaticStyles({
    desktop: {
      color: colors.principal.white,
      textDecoration: "none",
      justifySelf: "center",

      ":focus": {
        outline: "none",
      },
    },
  }),
  fadeIn: createStaticStyles({
    common: {
      opacity: 1,
      transition: "opacity 300ms ease, transform 300ms ease",
      transform: "translateY(0)",
    },
  }),
};

export const StickyFiltersSearchBar = ({
  filtersModalState,
  ...props
}: DoctorListFiltersProps) => {
  const { isMobile } = useScreenDetector();
  const { searchLabel } = useAppConfig();
  const { routePath } = useRoutePath();
  const { staticStyles } = useStaticStyles();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  if (isMobile) {
    return (
      <div
        css={[
          staticStyles(styles.container),
          visible ? staticStyles(styles.fadeIn) : undefined,
        ]}
      >
        <FilterButton.Outlined
          badge={props.isAnyParamSet}
          onPress={filtersModalState?.open}
        />
        <SearchBar variant="sticky" searchLabel={searchLabel?.text} />
      </div>
    );
  }

  return (
    <div
      css={[
        staticStyles(styles.container),
        visible ? staticStyles(styles.fadeIn) : undefined,
      ]}
    >
      <Link css={staticStyles(styles.logo)} to={routePath({ path: "/" })}>
        <img src="/logo_blue.svg" alt="logo" />
      </Link>
      <div css={staticStyles(styles.filters)}>
        <SearchBar variant="sticky" searchLabel={searchLabel?.text} />
        <DoctorListFilters {...props} />
      </div>
    </div>
  );
};
